import { render } from "./Index.vue?vue&type=template&id=8b66db12&scoped=true"
const script = {}

import "./Index.vue?vue&type=style&index=0&id=8b66db12&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b66db12"]])

export default __exports__